import PricingSetupApp from "./PricingSetupApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";
import pricing from "../Api/pricing";
import { defineStore } from "pinia";
import { PricingDefinition } from "../Common/Pricing/types";
import { ExistingPaymentGatewayConfig } from "../Api/paymentGatewayConfig";
import { CategoryKeyValue } from "../Api/Categories/categories";

export const usePricingSetupStore = defineStore("pricing-setup-store", {
    state: () => {
        return {
            userId: 0,
            eventId: 0,
            eventTimezone: "",
            pricingDefinitions: [] as PricingDefinition[],
            enableOnlinePaymentsSetting: false,
            allLevelsCategories: [] as CategoryKeyValue[],
            isFederationApproved: true,
        };
    },
    actions: {
        refreshPricingDefinitions(): Promise<void> {
            return pricing.getAllDefinitions(this.eventId).then(pricingDefinitions => {
                this.pricingDefinitions = pricingDefinitions;
            });
        },
    },
});

export const usePaymentGatewayConfigStore = defineStore("payment-gateway-config-store", {
    state: () => {
        return {
            view: "",
            chosenConfig: null as ExistingPaymentGatewayConfig | null,
            currenciesMap: {} as Record<string, boolean>,
            przelewy24SignUpUrl: "",
        };
    },
});

export default vueAppWithPinia(PricingSetupApp);
